import {FileManager} from '../../shared/Models/FileManager';

export class ServiceSubjectItem {
  public id: number;
  public name?: string;
  public description?: string;
  public status: boolean;
  public required: boolean;
  public position: number;
  public parentId?: number;
  public parent?: number;
  public serviceSubjectItems?: ServiceSubjectItem[];
  public deletedAt: any;
  public translations: any;
  public translationEntries ?= {};
  public translationKeys ?= [];
  public thumbnail: FileManager | number;
  public attachments: Array<FileManager> | Array<number>;
  constructor() {
    this.translations = [];
  }
}
